import { cloneDeep } from 'lodash'

import { SendingTypes } from '@sigmasms/shared-types'

import { proxy } from '@/utils'

import render from './render'

const defaultPrice = 0.1
const defaultValue = {
  price: [ defaultPrice ],
  action: 'decrease',
  priceRanges: [],
  packets: [],
  rules: []
}

export default {
  name: 'Rules',

  mixins: [ proxy({ type: 'array' }) ],

  props: {
    source: String,
    hasDefault: Boolean,
    isNew: Boolean
  },

  watch: {
    hasDefault(value) {
      if (!value && !this.proxy.length) {
        this.add()
      }
    }
  },

  methods: {
    updateRule(index, rule) {
      const rules = this.proxy.slice()
      rules.splice(index, 1, rule)
      this.proxy = rules
    },

    removeRule(index) {
      const rules = this.proxy.slice()
      rules.splice(index, 1)
      this.proxy = rules
    },

    add() {
      const data = cloneDeep(defaultValue)
      if (this.source === SendingTypes.voice) {
        if (data.price.length < 2) {
          data.price.push(defaultPrice)
        }
      }
      this.proxy.push(data)
    },

    watchProxyHandler() {
      if (!this.proxy.length && !this.hasDefault) {
        this.add()
      }

      this.transmitValue()
    }
  },

  render
}
